import {
    IValidateActivationLinkRequest,
    IValidateActivationLinkResponse,
} from '../../../../lib/entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IValidateActivationLinkUseCase {
    execute(
        params: IValidateActivationLinkRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IValidateActivationLinkResponse>;
}

export class ValidateActivationLinkUseCase implements IValidateActivationLinkUseCase {
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    async execute(
        params: IValidateActivationLinkRequest,
        apiToken?: { [key: string]: string }
    ): Promise<IValidateActivationLinkResponse> {
        return await this.subscriptionRepository.validateActivationLink(params, apiToken);
    }
}
